module.exports = {
    toolbarItems: ['heading', 'bold', 'italic', 'strike', 'ul', 'ol', 'link'],
};
